// Frontend service layer for Bot Configuration saves.
// Endpoint per SRS/Starter Pack: PATCH /api/bots/{id}/
// DEMO NOTE: backend is not available yet, so this is a mock/in-memory
// response. Swap for a real fetch('/api/bots/{id}/', { method: 'PATCH', ... })
// once the backend contract is ready, keeping the same function signature.

export function mockSave(forceError) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (forceError) reject(new Error('network'));
      else resolve(true);
    }, 900);
  });
}
